<div *ngIf="(size | async) as s">
  <p>{{s.size}} </p>
  <mat-progress-bar *ngIf="s.size" mode="determinate" [value]="s.percent" style="width: 200px">
  </mat-progress-bar>
</div>
